import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum EProjectsRoute {
  projects = 'projects',
  list = 'list',
  view = 'view',
}

CamRoutes.addRoute({
  key: EProjectsRoute.projects,
  url: 'projects',
  children: [
    {
      key: EProjectsRoute.list,
      url: 'list',
    },
    {
      key: EProjectsRoute.view,
      url: 'view/:id',
    },
  ],
});

export const projectsRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([EProjectsRoute.projects, EProjectsRoute.list]),
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([EProjectsRoute.projects, EProjectsRoute.list]),
    loadComponent: () => import('./pages/list/all-projects-list.component').then(c => c.AllProjectsListPage),
  },
  {
    path: CamRoutes.getUrl([EProjectsRoute.projects, EProjectsRoute.view]),
    loadComponent: () => import('./pages/view/project-view.component').then(c => c.ProjectViewPage),
  },
];
